export default __webpack_public_path__ + "static/media/ornament_1.42a4246a.png";